module.exports = __webpack_public_path__ + "static/media/password.a4bbb76b.svg";